import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from "@air/next-icons";
import { useAirModal } from "@air/provider-modal";
import { useShortIdContext } from "@air/provider-short-id";
import { memo, useCallback } from "react";
import { AssetModalContentDesktopLayout } from "~/components/AssetModalV2/AssetModalContentDesktopLayout";
import { AssetModalDesktopLayout } from "~/components/AssetModalV2/AssetModalDesktopLayout";
import { PublicAssetContentFooter } from "~/components/AssetModalV2/Content/Footer/PublicAssetContentFooter";
import { PublicContentHeader } from "~/components/AssetModalV2/Content/Header/PublicContentHeader";
import { LeftContentPanel } from "~/components/AssetModalV2/Content/Panel/components/LeftContentPanel";
import { PublicBoardAssetHeader } from "~/components/AssetModalV2/Header/PublicBoardAssetHeader";
import { PublicInfoPanel } from "~/components/AssetModalV2/InfoPanel/PublicAssetInfoPanel";
import { PublicVersionsPanel } from "~/components/AssetModalV2/VersionsPanel/PublicVersionsPanel";
import { PublicImageVisualizer } from "~/components/AssetModalV2/Visualizer/ImageVisualizer/PublicImageVisualizer";
import { PublicPDFVisualizer } from "~/components/AssetModalV2/Visualizer/PDFVisualizer/PublicPDFVisualizer";
import { PublicVideoVisualizer } from "~/components/AssetModalV2/Visualizer/VideoVisualizer/PublicVideoVisualizer";
import { Visualizer } from "~/components/AssetModalV2/Visualizer/Visualizer";
import { SharePublicClipModal } from "~/components/Modals/SharePublicClipModal";
import { getPublicClipInABoardShareUrl } from "~/swr-hooks/shortUrl/utils";
import { getBoardIdFromPath, getClipIdFromPath } from "~/utils/PathUtils";
export const PublicBoardAssetModalDesktopLayout = /*#__PURE__*/ memo(()=>{
    const [sharePublicClip] = useAirModal(SharePublicClipModal);
    const { shortId } = useShortIdContext();
    const onShare = useCallback(()=>{
        const clipId = getClipIdFromPath(window.location.pathname);
        const boardId = getBoardIdFromPath(window.location.pathname);
        if (!boardId || !clipId) return;
        sharePublicClip({
            id: clipId,
            url: getPublicClipInABoardShareUrl(shortId, clipId, boardId),
            trackLocation: "public-asset-page"
        });
    }, [
        sharePublicClip,
        shortId
    ]);
    const options = [
        {
            label: "Share a link",
            id: "share-link",
            type: "item",
            prefix: /*#__PURE__*/ _jsx(Link, {
                className: "size-4"
            }),
            onSelect: onShare
        }
    ];
    return /*#__PURE__*/ _jsx(AssetModalDesktopLayout, {
        contextMenuOptions: options,
        header: /*#__PURE__*/ _jsx(PublicBoardAssetHeader, {}),
        rightPanel: /*#__PURE__*/ _jsx(PublicInfoPanel, {}),
        content: /*#__PURE__*/ _jsx(AssetModalContentDesktopLayout, {
            header: /*#__PURE__*/ _jsx(PublicContentHeader, {}),
            leftPanel: /*#__PURE__*/ _jsx(LeftContentPanel, {}),
            footer: /*#__PURE__*/ _jsx(PublicAssetContentFooter, {}),
            content: /*#__PURE__*/ _jsx(Visualizer, {
                ImageVisualizer: PublicImageVisualizer,
                VideoVisualizer: PublicVideoVisualizer,
                PDFVisualizer: PublicPDFVisualizer
            })
        }),
        leftPanel: /*#__PURE__*/ _jsx(PublicVersionsPanel, {})
    });
});
PublicBoardAssetModalDesktopLayout.displayName = "PublicBoardAssetModalDesktopLayout";
